import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; // Install jwt-decode if using JWT tokens

const ProtectedRoute = ({ children }) => {
    const token = sessionStorage.getItem('token');

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    try {
        const decoded = jwtDecode(token); // Decode the token
        const currentTime = Date.now() / 1000; // Current time in seconds
        if (decoded.exp < currentTime) {
            localStorage.removeItem('token'); // Remove expired token
            return <Navigate to="/login" replace />;
        }
    } catch (error) {
        console.error('Invalid token:', error);
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;